<template>
  <div v-if="loading" class="settings-state">
    <Loader2 class="icon settings-spinner" />
    <span>{{ loadingLabel }}</span>
  </div>
  <div v-else-if="error" class="settings-state settings-state-error">
    <AlertTriangle class="icon" />
    <span>{{ error }}</span>
    <button type="button" class="btn" @click="$emit('retry')">Retry</button>
  </div>
  <div v-else-if="empty" class="settings-state">
    <slot name="empty">
      <Inbox class="icon" />
      <span>{{ emptyLabel }}</span>
    </slot>
  </div>
  <slot v-else />
</template>

<script setup lang="ts">
import { AlertTriangle, Inbox, Loader2 } from 'lucide-vue-next';

withDefaults(defineProps<{
  loading?: boolean;
  error?: string | null;
  empty?: boolean;
  loadingLabel?: string;
  emptyLabel?: string;
}>(), {
  loading: false,
  error: null,
  empty: false,
  loadingLabel: 'Loading…',
  emptyLabel: 'Nothing to show yet.'
});

defineEmits<{
  retry: [];
}>();
</script>
